import { render, staticRenderFns } from "./SatinalmaSiparisleri.vue?vue&type=template&id=721c537f&"
import script from "./SatinalmaSiparisleri.vue?vue&type=script&lang=js&"
export * from "./SatinalmaSiparisleri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports